// Globals
import React from 'react';
import { LinkOutlined } from '@ant-design/icons';

// Components
import { StyledActionsWrap, StyledActionButton, StyledUrl } from './ProductsTableActionsStyles';
import { CloseEyeIcon, EditIcon, EyeIcon, TrashIcon } from '@/icons';
import { Link } from '@/ui';
import { COLORS } from '@/theme';

// Models
import { IProduct } from '@/models/products.model';
import { ROUTES } from '@/models/router.model';

// Helper
import { WEBSITE_PRODUCT_URL } from '../../helpers';

type TProductsTableActions = {
  record: IProduct;
  setProductForDelete: (product: IProduct) => void;
  handleToggleActive: (product: IProduct) => void;
  canManage: boolean;
};

const ProductsTableActions = ({
  setProductForDelete,
  handleToggleActive,
  record,
  canManage,
}: TProductsTableActions) => {
  const handleDelete = () => setProductForDelete(record);
  const onToggleActive = () => handleToggleActive(record);
  const isVisible = record.active;
  const isLinkExist = record?.slug && record?.active;
  const link = `${WEBSITE_PRODUCT_URL}/${record?.slug}`;

  return (
    <StyledActionsWrap>
      {/* Open the (read-only for view roles) product card — always available to anyone who can see the list. */}
      <Link path={`${ROUTES.PRODUCTS}/${record.id}`}>
        <StyledActionButton $color={COLORS.PALE_YELLOW}>
          <EditIcon />
        </StyledActionButton>
      </Link>
      {canManage && (
        <>
          <StyledActionButton $color={COLORS.RED} onClick={handleDelete}>
            <TrashIcon />
          </StyledActionButton>
          <StyledActionButton $color={isVisible ? COLORS.PALE_YELLOW : COLORS.SOFT_GRAY} onClick={onToggleActive}>
            {isVisible ? <EyeIcon /> : <CloseEyeIcon />}
          </StyledActionButton>
        </>
      )}
      {!!isLinkExist && (
        <StyledUrl href={link} target="_blank" rel="noreferrer">
          <StyledActionButton $color={COLORS.GREEN}>
            <LinkOutlined />
          </StyledActionButton>
        </StyledUrl>
      )}
    </StyledActionsWrap>
  );
};

export default ProductsTableActions;
